var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(_vm.text)+"  "),_c('an-link',{attrs:{"href":"https://status.animaapp.com","target":"_blank","variant":"primary"}},[_vm._v("See status")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }